import { ChevronRight } from 'lucide-react'
import { StatusBadge } from '../../common/StatusBadge'
import styles from '../../CommandCenterApprovals.module.css'

function requestDate(value) {
  if (!value) return 'Request time unavailable'
  return new Date(value).toLocaleDateString(undefined, { month: 'short', day: 'numeric' })
}

function requesterName(group) {
  return group.created_by_admin?.display_name
    || group.created_by_admin?.email
    || 'Requester unavailable'
}

export function ApprovalQueue({
  groups = [],
  total = groups.length,
  selectedId,
  selectedButtonRef,
  disabled = false,
  onSelect,
}) {
  return (
    <section className={styles.queue} aria-labelledby="approval-queue-title">
      <header className={styles.queueHeader}>
        <div>
          <h2 id="approval-queue-title">Pending review</h2>
          <span>{total} pending</span>
        </div>
        <StatusBadge status="warning">{groups.length}</StatusBadge>
      </header>

      <ul className={styles.queueList}>
        {groups.map((group) => {
          const selected = selectedId === group.group_id
          const organizations = (group.destinations || [])
            .map((destination) => destination.organization_name || destination.organization_slug)
            .filter(Boolean)
          const label = group.document?.shared?.label || 'Untitled distributed post'
          return (
            <li key={group.group_id}>
              <button
                ref={selected ? selectedButtonRef : undefined}
                type="button"
                className={`${styles.queueItem} ${selected ? styles.queueItemSelected : ''}`.trim()}
                aria-pressed={selected}
                aria-label={`Review ${label}`}
                disabled={disabled}
                onClick={() => onSelect(group.group_id)}
              >
                <span className={styles.queueItemMain}>
                  <strong>{label}</strong>
                  <span>{organizations.join(', ') || 'Organizations unavailable'}</span>
                </span>
                <span className={styles.queueItemMeta}>
                  <span>{requesterName(group)}</span>
                  <span aria-hidden="true">·</span>
                  <span>{requestDate(group.created_at)}</span>
                </span>
                <ChevronRight className={styles.queueItemArrow} size={17} aria-hidden="true" />
              </button>
            </li>
          )
        })}
      </ul>

      {total > groups.length ? (
        <p className={styles.queueLimit} role="status">
          Showing {groups.length} of {total} pending approvals.
        </p>
      ) : null}
    </section>
  )
}
